import React, { useEffect, useState } from 'react';
import { useCheckoutViewModel } from '../viewmodels/useCheckoutViewModel';
import { useGetRegionQuery } from '../services/api';
import { fetchRuntimeConfig } from '../services/config';
import AddressForm from './AddressForm';

interface ShippingFormProps {
  checkout: ReturnType<typeof useCheckoutViewModel>;
}

const ShippingForm: React.FC<ShippingFormProps> = ({ checkout }) => {
  const {
    checkoutData,
    updateEmail,
    updateShippingAddress,
    updateBillingAddress,
    updateSameAsShipping,
    goToNextStep,
    errors,
  } = checkout;

  const [regionId, setRegionId] = useState<string | null>(null);

  // Fetch region ID from runtime config
  useEffect(() => {
    fetchRuntimeConfig().then((config) => {
      setRegionId(config.medusa.regionId);
    });
  }, []);

  // Fetch region with countries
  const {
    data: regionData,
    isLoading: isLoadingRegion,
  } = useGetRegionQuery(regionId!, {
    skip: !regionId,
  });

  const countries = regionData?.region?.countries || [];
  const isLoadingCountries = isLoadingRegion;

  return (
    <div className="shipping-form">
      <div className="form-section">
        <h2>Contact Information</h2>
        <div className="form-group">
          <label htmlFor="email">Email Address *</label>
          <input
            id="email"
            name="email"
            type="email"
            value={checkoutData.email}
            onChange={(e) => updateEmail(e.target.value)}
            className={errors.email ? 'error' : ''}
            placeholder="your@email.com"
          />
          {errors.email && <span className="error-text">{errors.email}</span>}
        </div>
      </div>

      <div className="form-section">
        <h2>Shipping Address</h2>
        <AddressForm
          address={checkoutData.shipping_address}
          onAddressChange={updateShippingAddress}
          errors={errors}
          fieldPrefix="shipping_"
          countries={countries}
          isLoadingCountries={isLoadingCountries}
        />
      </div>

      <div className="form-section">
        <div className="checkbox-group">
          <label className="checkbox-label">
            <input
              type="checkbox"
              checked={checkoutData.same_as_shipping}
              onChange={(e) => updateSameAsShipping(e.target.checked)}
            />
            <span className="checkmark"></span>
            Billing address same as shipping
          </label>
        </div>

        {!checkoutData.same_as_shipping && (
          <>
            <h3>Billing Address</h3>
            <AddressForm
              address={checkoutData.billing_address}
              onAddressChange={updateBillingAddress}
              errors={errors}
              fieldPrefix="billing_"
              countries={countries}
              isLoadingCountries={isLoadingCountries}
            />
          </>
        )}
      </div>

      <div className="form-actions">
        <button
          type="button"
          onClick={goToNextStep}
          className="btn btn-primary btn-large"
          data-testid="continue-to-payment"
        >
          Continue to Payment
        </button>
      </div>
    </div>
  );
};

export default ShippingForm;